import { cn } from '@components/primitives';

import css from './styles.module.css';

type SkeletonProps = {
  width: number | string;
  height: number | string;
  className?: string;
};

export function Skeleton({ width, height, className }: SkeletonProps) {
  return (
    <div className={cn(css.skeleton, className)} style={{ width, height }} />
  );
}
